var _defs, _style, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabletvWhiteSvgTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 20",
    width: 23,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cabletv_white-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.4 6.62h15.26v9.53h-15.26z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m18.6 14.6c0 0.4-0.1 0.8-0.5 1.1-0.3 0.3-0.8 0.5-1.2 0.5-2.9 0-8.9 0-11.7 0-0.5 0-0.9-0.2-1.3-0.5-0.3-0.3-0.5-0.7-0.5-1.1 0-1.7 0-4.7 0-6.4 0-0.4 0.2-0.8 0.5-1.1 0.4-0.3 0.8-0.5 1.3-0.5 2.8 0 8.8 0 11.7 0 0.4 0 0.9 0.2 1.2 0.5 0.4 0.3 0.5 0.7 0.5 1.1 0 1.7 0 4.7 0 6.4zm-0.8-7.2c-0.3-0.2-0.6-0.3-0.9-0.3-2.9 0-8.9 0-11.7 0-0.3 0-0.7 0.1-0.9 0.3-0.2 0.2-0.4 0.5-0.4 0.8 0 1.7 0 4.7 0 6.4 0 0.3 0.2 0.6 0.4 0.8 0.2 0.2 0.6 0.3 0.9 0.3 2.8 0 8.8 0 11.7 0 0.3 0 0.6-0.1 0.9-0.3 0.2-0.2 0.3-0.5 0.3-0.8 0-1.7 0-4.7 0-6.4 0-0.3-0.1-0.6-0.3-0.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m15.5 14.1c0 0.4-0.4 0.7-0.8 0.7-1.7 0-7.2 0-8.9 0-0.5 0-0.8-0.3-0.8-0.7 0-1.2 0-4.3 0-5.4 0-0.4 0.3-0.7 0.8-0.7 1.7 0 7.2 0 8.9 0 0.4 0 0.8 0.3 0.8 0.7zm-0.8-5.7c-1.7 0-7.2 0-8.9 0-0.2 0-0.3 0.1-0.3 0.2 0 1.2 0 4.3 0 5.5 0 0.1 0.1 0.2 0.3 0.2 1.7 0 7.2 0 8.9 0 0.2 0 0.3-0.1 0.3-0.2v-5.5c0-0.1-0.1-0.2-0.3-0.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m13.1 6.8v0.3h-4.2c-0.1 0-0.2-0.1-0.2-0.3q0 0 0 0c0-0.4 0.2-0.8 0.5-1.1 0.4-0.3 0.8-0.4 1.3-0.4q0.5 0 1.1 0c1 0 1.8 0.7 1.8 1.5zm-0.3-0.2c-0.1-0.5-0.6-0.9-1.3-0.9q-0.5 0-1 0c-0.4 0-0.7 0.1-1 0.3q-0.3 0.3-0.3 0.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m11 5.1l3.6-2.1c0.1 0 0.2 0 0.3 0.1 0.1 0.1 0.1 0.2 0 0.3l-3.7 2.2q-0.2 0-0.3 0l-3.7-2.2c-0.1-0.1-0.1-0.2-0.1-0.3 0.1-0.1 0.3-0.1 0.4-0.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m17.6 10.9c0 0.2-0.1 0.3-0.3 0.3h-1c-0.1 0-0.3-0.1-0.3-0.3v-0.9c0-0.1 0.2-0.2 0.3-0.2h1c0.2 0 0.3 0.1 0.3 0.2zm-1.1-0.7v0.5h0.6v-0.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m17.6 12.7c0 0.2-0.1 0.3-0.3 0.3h-1c-0.1 0-0.3-0.1-0.3-0.3v-0.9c0-0.1 0.2-0.2 0.3-0.2h1c0.2 0 0.3 0.1 0.3 0.2zm-1.1-0.6v0.4h0.6v-0.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabletvWhiteSvgTrans);
export default __webpack_public_path__ + "static/media/Cabletv_white-svg-trans.f6286df510c1a46c59fadbef5e78c5c9.svg";
export { ForwardRef as ReactComponent };